import "./index.css";
import Header from "./layouts/Header/Header";
import Sidebar from "./layouts/Sidebar/Sidebar";
import PublicRoutes from "./layouts/Routers/PublicRoutes";
import Cookies from "js-cookie";
import AppRouters from './layouts/Routers/Routers';
import React, { useEffect, useState } from "react";
import authActions from "./redux/auth/actions";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import InactivityLogout from "./utils/InactiveLogout";


function App() {
  const token = sessionStorage.getItem("biller_access");
  const dispatch = useDispatch();
  const { getProfile } = authActions;
  const location = useLocation();


  useEffect(() => {
    if (token) {
      dispatch(getProfile());
    }
  }, [location.pathname]);
  

  useEffect(() => {
    if (window.top !== window.self) {
      window.top.location = window.self.location;
    }
  }, []);
  

  return (
    <div className="App">
      {token ? (
        <>
          <Header />
          <div className="partDashboard">
            <Sidebar />
            <AppRouters />
            <InactivityLogout />
          </div>
        </>
      ) : (
        <PublicRoutes />
      )}
    </div>
  );
}

export default App;
